define([], () => {
    return ['$window', ($window) => {
        const localStoragePrefix = "mf_recurrent_user_"

        const service = {
            setDataToLocalStorage: (submission, isMotorCycleMode) => setDataToLocalStorage(submission, isMotorCycleMode),
            clearDataInLocalStorage: () => clearDataInLocalStorage(),
        };

        function setDataToLocalStorage(submission, isMotorCycleMode) {
            if (submission && checkIfLocalStorageWork()) {
                const localStorage = $window['localStorage'];

                if (submission.draftData) {
                    const draftdata = submission.draftData;
                    localStorage[localStoragePrefix + 'encrypted_quote_id'] = draftdata.encryptedQuoteID;
                    localStorage[localStoragePrefix + 'product_code'] = draftdata.productCode;
                    localStorage[localStoragePrefix + 'subproduct_code'] = draftdata.subproductCode;
                    localStorage[localStoragePrefix + 'salespoint_code'] = draftdata.salespointCode;

                    if (draftdata.lobs && draftdata.lobs.mFPLine && draftdata.lobs.mFPLine.vehicles) {
                        const vehicle = draftdata.lobs.mFPLine.vehicles[0];
                        localStorage[localStoragePrefix + 'vehicle_make'] = vehicle.make;
                        localStorage[localStoragePrefix + 'vehicle_model'] = vehicle.type;
                        localStorage[localStoragePrefix + 'vehicle_type'] = isMotorCycleMode ? 'motorcycle' : 'car';
                    }

                    if (draftdata.accountHolder && draftdata.accountHolder.contact) {
                        localStorage[localStoragePrefix + 'language'] = submission.draftData.accountHolder.contact.primaryLanguage
                            .toLowerCase()
                            .replace('_us', ''); // 'en_US' -> 'en'
                    }
                }
                localStorage[localStoragePrefix + 'last_visit'] = new Date();
            }
        }

        function clearDataInLocalStorage() {
            if (checkIfLocalStorageWork()) {
                const localStorage = $window['localStorage'];

                Object.entries(localStorage)
                    .filter(value => value[0].startsWith(localStoragePrefix))
                    .forEach(value => localStorage.removeItem(value[0]))
            }
        }

        function checkIfLocalStorageWork() {
            var storage;
            try {
                storage = $window['localStorage'];
                var x = '__storage_test__';
                storage.setItem(x, x);
                storage.removeItem(x);
                return true;
            } catch (e) {
                return false;
            }
        }

        return service;
    }];
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/services/RecurrentUserService.js